import { Link } from 'react-router-dom';

const steps = [
  {
    n: '01',
    icon: 'ri-focus-3-line',
    title: '先看时间线',
    desc: '同一颗瓜往往几经反转，按时间线读，才不会只看到单一片段而被带节奏。',
  },
  {
    n: '02',
    icon: 'ri-scan-2-line',
    title: '认准分类目录',
    desc: '带货、圈内、品牌、新规各成一栏。按你想补的主题逛，进度一目了然，吃得更省时。',
  },
  {
    n: '03',
    icon: 'ri-heart-line',
    title: '理性吃瓜',
    desc: '围观要有分寸，对「网传待核实」的信息多留一分判断，也别拿别人的私事当谈资。',
  },
];

export default function GuideStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="container-page grid grid-cols-1 gap-6 lg:grid-cols-3">
        {steps.map((s) => (
          <div key={s.n} className="relative overflow-hidden rounded-2xl bg-background-100 p-6 md:p-8">
            <span className="absolute right-5 top-4 font-heading text-5xl font-black text-background-200" aria-hidden="true">
              {s.n}
            </span>
            <span className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-primary-600 text-xl text-background-50">
              <i className={s.icon} aria-hidden="true" />
            </span>
            <h3 className="relative mt-5 font-heading text-lg font-bold text-foreground-950 md:text-xl">{s.title}</h3>
            <p className="relative mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
          </div>
        ))}

        <div className="flex flex-col justify-between gap-4 rounded-2xl bg-foreground-950 p-6 md:p-8 lg:col-span-3">
          <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <h3 className="text-xl font-bold text-background-50 md:text-2xl">还没想好吃哪颗瓜？先去热榜看看大家都在聊什么。</h3>
              <p className="mt-1 text-sm text-background-200 md:text-[15px]">热榜每 30 分钟更新一次，反映当下最受关注的瓜料讨论趋势。</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a href="#hot" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400">
                <i className="ri-fire-fill" aria-hidden="true" />
                去热榜围观
              </a>
              <Link to="/about" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-100 hover:text-foreground-900">
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}